import Vue from 'vue';

import {
  isMobileDevice,
  isFirstPhone,
} from '@/plugins/device/device-detection';

const tablet = 768;
const desktop = 980;
const wide = 1248;

const mobileMaxWidth = tablet - 1;
const tabletMaxWidth = desktop - 1;
const desktopMaxWidth = wide - 1;

export function createDevice () {
  return new Vue({
    data () {
      const isClient = true;
      const initialWidth = isClient ? window.innerWidth : 0;
      const initialUserAgent = isClient ? (navigator.userAgent || navigator.vendor || window.opera) : '';

      return {
        width: initialWidth,
        userAgent: initialUserAgent,
        isSmartDevice: isMobileDevice(initialUserAgent),
        isFirstPhone: isFirstPhone(initialUserAgent),
        isMobile: isClient ? initialWidth <= mobileMaxWidth : false,
        isTablet: isClient ? initialWidth > mobileMaxWidth
          && initialWidth <= tabletMaxWidth : false,
        isDesktop: isClient ? initialWidth > tabletMaxWidth
          && initialWidth <= desktopMaxWidth : false,
        isWide: isClient ? initialWidth > desktopMaxWidth : false,
      };
    },
    computed: {
      isMobileOrTablet () {
        return this.isMobile || this.isTablet;
      },
      isNeitherMobileOrTablet () {
        return !this.isMobileOrTablet;
      },
    },
    watch: {
      width () {
        this.isMobile = this.width <= mobileMaxWidth;
        this.isTablet = this.width > mobileMaxWidth && this.width <= tabletMaxWidth;
        this.isDesktop = this.width > tabletMaxWidth && this.width <= desktopMaxWidth;
        this.isWide = this.width > desktopMaxWidth;
      },
      userAgent () {
        this.isSmartDevice = isMobileDevice(this.userAgent);
        this.isFirstPhone = isFirstPhone(this.userAgent);
      },
    },
    methods: {
      // Watch doesn't work on server so we manually set properties
      serverInit (userAgent) {
        this.userAgent = userAgent;
        this.isMobile = isMobileDevice(userAgent);
      },
      browserInit () {
        window.addEventListener('resize', () => {
          this.updateWidth();
        });
      },
      updateWidth () {
        this.width = window.innerWidth;
      },
    },
  });
}

export default {
  install ($Vue) {
    /* istanbul ignore next: it's hard to test $api existing */
    if (!('$device' in $Vue.prototype)) {
      Object.defineProperty($Vue.prototype, '$device', {
        get () {
          return this.$root._device;
        },
      });

      $Vue.mixin({
        beforeCreate () {
          if (this.$options.device !== undefined) {
            this._device = this.$options.device;
            this._device.browserInit();
          }
        },
      });
    }
  },
};
